/**
 * capturarInfoTecnica — lee navigator/screen para adjuntar contexto técnico
 * al ticket. Detección best-effort por inspección del userAgent.
 */
export function capturarInfoTecnica() {
  return {
    navegador: detectarNavegador(),
    os: detectarOS(),
    resolucion: `${window.screen.width}x${window.screen.height}`,
    url: window.location.href,
    userAgent: navigator.userAgent,
    fecha: new Date().toISOString(),
  };
}

function detectarNavegador() {
  const ua = navigator.userAgent;
  let m;
  // Edge y Opera contienen "Chrome" en el UA → comprobarlos primero.
  if ((m = ua.match(/Edg\/(\d+)/))) return `Edge ${m[1]}`;
  if ((m = ua.match(/OPR\/(\d+)/)) || (m = ua.match(/Opera\/(\d+)/))) return `Opera ${m[1]}`;
  if ((m = ua.match(/Chrome\/(\d+)/)) && !/Edg\//.test(ua) && !/OPR\//.test(ua)) return `Chrome ${m[1]}`;
  if ((m = ua.match(/Firefox\/(\d+)/))) return `Firefox ${m[1]}`;
  if ((m = ua.match(/Version\/(\d+)[.\d]*\s*Safari/)) && !/Chrome/.test(ua)) return `Safari ${m[1]}`;
  if (/Safari/.test(ua) && !/Chrome/.test(ua)) return 'Safari';
  return 'Navegador desconocido';
}

function detectarOS() {
  const ua = navigator.userAgent;
  if (/Windows NT 10/.test(ua)) return 'Windows 10/11';
  if (/Windows/.test(ua)) return 'Windows';
  if (/Mac OS X/.test(ua) && !/iPhone|iPad|iPod/.test(ua)) return 'macOS';
  if (/Android/.test(ua)) return 'Android';
  if (/iPhone|iPad|iPod/.test(ua)) return 'iOS';
  if (/Linux/.test(ua)) return 'Linux';
  return 'Sistema desconocido';
}
